import { DatePipe } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { BaseResourceListComponent, Coluna, Compra, Filtro, GlobalService, LoginContabil } from 'eddydata-lib';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { CompraService } from '../../compra/service/compra.service';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-exportar-empenho',
  templateUrl: './exportar-empenho.component.html'
})
export class ExportarEmpenhoComponent extends BaseResourceListComponent<Compra, LoginContabil> {

  /**
   * Declaração de variáveis
   */

  public listaFiltros: Coluna[] = [];
  public menuFiltros: MenuItem[] = [];
  public ptBR: any;
  public datepipe: DatePipe;

  public selecionados: Compra[] = [];

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    public compraService: CompraService) {
    super(compraService, injector);
    this.datepipe = new DatePipe('pt');
    this.ptBR = new GlobalService().obterDataBR();
    this.usarExtendido = true;
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'orgao,favorecido,ficha,ficha.despesa,requerente,subelemento';
  }

  protected condicoesGrid(): {} {
    const filtros = this.obterFiltrosLista();
    const parametros = {
      'empenho.id$null': true,
      'exercicio.id': this.login.exercicio.id,
      'orgao.id': this.login.orgao.id,
      'excluido': false
    }
    return filtros ? Object.assign(parametros, filtros) : parametros;
  }

  protected ordenacaoGrid(): string[] {
    return ['data_compra$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {}
  }

  public beforeInit(): void {
    this.loadMenuFiltros(true);
  }

  protected afterInit(): void {
  }

  protected acaoRemover(model: Compra): Observable<Compra> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return null;
  }

  // ========================================================================
  // -------------------------- MÉTODOS DA CLASSE ---------------------------
  // ========================================================================


  public exportarCompras() {
    if (!this.selecionados || this.selecionados.length === 0) {
      toastr.warning('Não foi selecionado ordens de fornecimento para exportação');
      return;
    }
    this.compraService.exportarCompra(this.selecionados, this.login.exercicio.id, this.login.orgao.id)
      .subscribe((data) => {
        const empenhos = data.map((c) => c.empenho.numero.toString() + '/' + c.empenho.exercicio.ano)
          .join(',')
        toastr.success(`Ordens de fornecimento foram exportadas gerando os empenho (${empenhos}).`);
        this.selecionados = [];
        this.preencherGrid();
      }, (error) => toastr.error(error.error.payload))
  }

  private loadMenuFiltros(init?: boolean) {
    let filtros = this.obterColunasRelatorio();
    this.menuFiltros = filtros.map((l): MenuItem => {
      if (!l['filtro1'])
        l['filtro1'] = null;
      if (!l['filtro2'])
        l['filtro2'] = null;
      if (l.coluna === 'data_compra' && init) {
        l['filtro1'] = new Date();
        l['filtro2'] = new Date();
        this.adicionarFiltro(l);
      }
      return {
        label: l.titulo,
        icon: 'fa fa-plus',
        visible: !this.filtroAdicionado(l),
        command: (event) => {
          this.adicionarFiltro(l);
        }
      };
    });
  }


  private adicionarFiltro(coluna: Coluna) {
    if (!this.filtroAdicionado(coluna))
      this.listaFiltros.push(coluna);
    this.loadMenuFiltros();
  }

  public removerFiltro(coluna: Coluna) {
    let index = this.listaFiltros.indexOf(coluna);
    if (index || index === 0)
      this.listaFiltros.splice(index, 1);
    this.loadMenuFiltros();
  }

  public filtroAdicionado(coluna: Coluna): boolean {
    let filtro = this.listaFiltros.find((f) => f.coluna === coluna.coluna)
    return !(!filtro)
  }

  protected obterColunasRelatorio(): Coluna[] {
    const retorno: Coluna[] = [];
    retorno.push({ titulo: 'Número', coluna: 'numero', alignment: 'center', tipo: 'Number' });
    retorno.push({ titulo: 'Data Compra', coluna: 'data_compra', tipo: 'Date', alignment: 'center' });
    retorno.push({ titulo: 'Nº Requisição', coluna: 'rcms.numero', alignment: 'center', tipo: 'String' });
    retorno.push({ titulo: 'Fornecedor', coluna: 'favorecido.nome', tipo: 'String' });
    retorno.push({ titulo: 'Ficha', coluna: 'ficha.numero', alignment: 'center', tipo: 'String' });
    retorno.push({ titulo: 'Despesa', coluna: 'ficha.despesa.codigo', alignment: 'center', tipo: 'String' });
    retorno.push({ titulo: 'Requerente', coluna: 'requerente.nome', tipo: 'String' });
    retorno.push({ titulo: 'Contrato', coluna: 'contrato.numero', alignment: 'center', tipo: 'String', mask: '0000/0000' });
    retorno.push({ titulo: 'Licitação', coluna: 'licitacao.numero', alignment: 'center', tipo: 'String', mask: '0000/0000' });
    retorno.push({ titulo: 'Processo', coluna: 'processo', alignment: 'center', tipo: 'String', mask: '0000/0000' });
    return retorno;
  }

  private obterFiltrosLista(): {} {
    let filtros: {} = {};
    for (let filtro of this.listaFiltros) {
      let convert = this.converterFiltro(filtro);
      if (convert)
        if (!convert['length']) {
          filtros[convert['chave']] = convert['valor'];
        } else {
          for (let fs of <[]>convert) {
            filtros[fs['chave']] = fs['valor'];
          }
        }
    }
    return filtros;
  }

  private converterFiltro(coluna: Coluna): { chave: string, valor: string } | { chave: string, valor: string }[] {
    if (coluna.tipo === 'Number' && coluna['filtro1'])
      return { chave: `${coluna.coluna}`, valor: coluna['filtro1'] }
    if (coluna.tipo === 'String' && coluna['filtro1'])
      return { chave: `${coluna.coluna}$like`, valor: `%${coluna['filtro1']}%` };
    if (coluna.tipo === 'Date') {
      let filtro_data = [];
      if (coluna['filtro1'])
        filtro_data.push({ chave: `${coluna.coluna}$ge`, valor: this.datepipe.transform(coluna['filtro1'], 'yyyy-MM-dd') });
      if (coluna['filtro2'])
        filtro_data.push({ chave: `${coluna.coluna}$le`, valor: this.datepipe.transform(coluna['filtro2'], 'yyyy-MM-dd') });
      return filtro_data;
    }
    return null;
  }


  public selecionar(compra: Compra, select: boolean) {
    if (select)
      this.selecionados.push(compra);
    else
      this.selecionados = this.selecionados.filter((s) => s.id !== compra.id);
  }

  public validSelect(compra: Compra) {
    const sel = this.selecionados.find((s) => s.id === compra.id);
    return !(!sel)
  }

  public ngClassCols(cols: number, padrao: string): {} {
    let ngClass = {};
    if (cols)
      ngClass[`col-sm-${cols}`] = true;
    else
      ngClass[padrao] = true;
    return ngClass;
  }
}
